// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"9952c1b8","186":"5b228953","225":"f21ff8bb","344":"3331c28b","372":"2deed6fe","377":"350dc44e","443":"645d3739","738":"e4d298c3","815":"09f86a05","841":"1b5863cb","849":"843051ec","856":"11df61ef"}[chunkId] + ".chunk.js";
};